import { Component } from '@angular/core';
import { CommonService } from 'src/app/core/services/common.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { RestService } from 'src/app/core/services/rest.service';

@Component({
  selector: 'app-log-out',
  templateUrl: './log-out.component.html',
  styleUrls: ['./log-out.component.scss']
})
export class LogOutComponent {
  loginUrl: any;
  constructor(private restService: RestService, private loader: LoaderService, 
    private commonService: CommonService) { }
  ngOnInit() {
    this.logOutWithRedirect()
  }
  logOutWithRedirect() {
    this.loader.show();
    let params = {
    }
    this.restService.postUADLogin(params, 'api/digital/core/Account/Logout').subscribe(
      (data) => {
        if (data.rcode == 200) {
          this.loader.hide();
          this.loginUrl = data.rObj.redirectURL
          localStorage.clear()
          window.location.href = this.loginUrl
        }
        else {
          this.commonService.handleRcodeError(data)
        }
      },
      (error) => {
        this.commonService.handleStatusError(error);
      }
    );


  }
}
